<template>
  <div class="select-dataset-dailog dialog col-block">
    <div class="description-container">
      <div class="description" v-html="$t('DIALOG.selectDataset.___description')"></div>
    </div>
    <div :style="{ height: '10px' }"></div>
    <hr class="no-margin">
    <div class="select-container row-block flex-start">
      <div :style="{ width: '10px' }"></div>
      <div class="vcf-container select-block col-block" :class="{ hover: hover['vcf'] }" :style="{ flex: 1 }" @mouseover="e => hover['vcf'] = true" @mouseleave="e => hover['vcf'] = false">
        <div class="select-title">{{ $t('DIALOG.selectDataset.select.title.___vcf') }}</div>
        <!-- <div class="select-description" v-html="$t('DIALOG.selectDataset.select.description.___vcf', { price:  priceMap['vcf'].price })"></div> -->
        <div :style="{ height: '20px' }"></div>
        <button class="circle-button" :class="['white-gray-button']" @click="e => $emit('changeModal', {}, 'vcf')">
          <span>{{ $t('COMMON.button.___vcf') }}</span>
        </button>
        <div :style="{ height: '10px' }"></div>
        <a class="select-option link" @click="e => checkBatchUploadPermission()">{{ $t('DIALOG.selectDataset.select.option.___batch') }}</a>
        <div :style="{ height: '20px' }"></div>
      </div>
      <div class="fastq-container select-block col-block" :class="{ hover: hover['fastq'] }" :style="{ flex: 1 }" @mouseover="e => hover['fastq'] = true" @mouseleave="e => hover['fastq'] = false">
        <div class="select-title">{{ $t('DIALOG.selectDataset.select.title.___fastq') }}</div>
        <!-- <div class="select-description" v-html="$t('DIALOG.selectDataset.select.description.___fastq', { price:  priceMap['fastq'].price })"></div> -->
        <div :style="{ height: '20px' }"></div>
        <button class="circle-button" :class="['main-button']" @click="e => $emit('changeModal', {}, 'fastq')">
          <span>{{ $t('COMMON.button.___fastq') }}</span>
        </button>
        <div :style="{ height: '20px' }"></div>
      </div>
      <div class="ubam-container select-block col-block" :class="{ hover: hover['ubam'] }" :style="{ flex: 1 }" @mouseover="e => hover['ubam'] = true" @mouseleave="e => hover['ubam'] = false">
        <div class="select-title">{{ $t('DIALOG.selectDataset.select.title.___ubam') }}</div>
        <!-- <div class="select-description" v-html="$t('DIALOG.selectDataset.select.description.___ubam', { price:  priceMap['ubam'].price })"></div> -->
        <div :style="{ height: '20px' }"></div>
        <button class="circle-button" :class="['white-gray-button']" @click="e => $emit('changeModal', {}, 'ubam')">
          <span>{{ $t('COMMON.button.___ubam') }}</span>
        </button>
        <div :style="{ height: '20px' }"></div>
      </div>
      <div :style="{ width: '10px' }"></div>
    </div>
  </div>
</template>

<script>
import { getBatchUploadSet } from '../../api'
import toastMethods from '../../mixins/toastMethods.vue'
import { priceMap } from '../../constants/global/data'

export default {
  mixins: [
    toastMethods
  ],
  computed: {
    // global
    priceMap () { return priceMap }
  },
  data () {
    return {
      hover: {
        vcf: false,
        fastq: false
      }
    }
  },
  methods: {
    async checkBatchUploadPermission () {
      try {
        let config = this.$ls.get('userInfo')
        await getBatchUploadSet(config)
        this.$router.push({ name: 'caseBatchUpload', params: { dataset: 'vcf' } })
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/selectDataset.vue